import { Building2, FileText, TriangleAlert, UserCog, Users, Briefcase, History } from "lucide-react";
import { ReactNode } from "react";
import { cn } from "@/utils/cn";

// Cor de cada entidade: usada no ícone do cabeçalho das páginas
const ENTIDADES = {
  seguro: { icon: FileText, cor: "bg-blue-500/10 text-blue-600 dark:text-blue-400" },
  sinistro: { icon: TriangleAlert, cor: "bg-rose-500/10 text-rose-600 dark:text-rose-400" },
  segurado: { icon: Users, cor: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400" },
  seguradora: { icon: Building2, cor: "bg-amber-500/10 text-amber-600 dark:text-amber-400" },
  usuario: { icon: UserCog, cor: "bg-violet-500/10 text-violet-600 dark:text-violet-400" },
  empresa: { icon: Briefcase, cor: "bg-sky-500/10 text-sky-600 dark:text-sky-400" },
  auditoria: { icon: History, cor: "bg-slate-500/10 text-slate-600 dark:text-slate-300" },
};

export type Entidade = keyof typeof ENTIDADES;

export const IconeTile = ({ cor, children, size = 'md' }: { cor: string; children: ReactNode; size?: 'sm' | 'md' }) => (
  <span aria-hidden className={cn("flex shrink-0 items-center justify-center rounded-lg", size === 'md' ? "h-10 w-10 [&_svg]:h-5 [&_svg]:w-5" : "h-7 w-7 rounded-md [&_svg]:h-4 [&_svg]:w-4", cor)}>
    {children}
  </span>
);

export const EntityIcon = ({ entidade }: { entidade: Entidade }) => {
  const { icon: Icon, cor } = ENTIDADES[entidade];
  return <IconeTile cor={cor}><Icon /></IconeTile>;
};

// Tipos de seguro: mesma cor no selo da lista e no gráfico do dashboard
export const TIPO_SEGURO_CORES: Record<string, { badge: string; barra: string }> = {
  VEICULAR: { badge: "bg-blue-500/10 text-blue-700 dark:text-blue-300", barra: "bg-blue-500" },
  RESIDENCIAL: { badge: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300", barra: "bg-emerald-500" },
  VIDA: { badge: "bg-rose-500/10 text-rose-700 dark:text-rose-300", barra: "bg-rose-500" },
  EMPRESARIAL: { badge: "bg-amber-500/10 text-amber-700 dark:text-amber-300", barra: "bg-amber-500" },
  CELULAR: { badge: "bg-violet-500/10 text-violet-700 dark:text-violet-300", barra: "bg-violet-500" },
};

export const Badge = ({ className, children, title }: { className?: string; children: ReactNode; title?: string }) => (
  <span title={title} className={cn("inline-flex items-center whitespace-nowrap rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-muted-foreground", className)}>
    {children}
  </span>
);
